import { BaseReactComponent } from "@/Common/Components/BaseReactComponent";
import { PopupModel } from "@/Common/Models/UI/PopupModel";
import { ButtonControl } from "../Buttons/ButtonControl";
import ButtonGroup from "../Buttons/ButtonGroup";

interface ICommonPopupComponent {
    id: string;
    model: PopupModel;
    onCloseCallback: () => void;
}

class CommonErrorComponent extends BaseReactComponent<ICommonPopupComponent> {
    public constructor(props: ICommonPopupComponent) {
        super(props);

        super.setOverlay(`CommonErrorComponent_${sessionStore.newId()}`, { zIndexAbovePopup: true });
    }

    public componentDidMount(): void {
        const container = document.body;
        const el = $(`#${this.props.id}`);

        // center popup
        if (this.props.model.centerPopupHorizontally) {
            const windowWidth = $(window).width();
            el.css({
                left: (windowWidth / 2) - (el.width() / 2),
                margin: 0
            });
        }

        const dragOptions = {
            containment: container,
            handle: ".p-header",
            stop: () => {
                el.draggable("destroy");
                window.setTimeout(() => el.draggable(dragOptions), 80);
            }
        };

        el.draggable(dragOptions);
    }

    public componentWillUnmount(): void {
        super.componentWillUnmount();
    }

    public render(): JSX.Element {
        let model = this.props.model;

        let showOk = model.showOk || (!model.showCancel && !model.altButtonLabel); // there must be at least one button, or the user can't close it

        const firstLineStyles: React.CSSProperties = {};
        if (model.addAdditionalSpace)
            firstLineStyles.marginBottom = "10px";

        if (model.boldFirstLineOfList)
            firstLineStyles.fontWeight = "bold";

        return (
            <div className={`dsq-nip-popup auto ${model.autoWidth ? "autoWidth" : ""} ${model.popupClass} common-popup`} id={this.props.id}>
                <div className="dsn-header p-header popup-header-content-container">
                    <h4>{model.title}</h4>
                    {model.showCloseX && <a className="close" aria-label="Close" onClick={() => this.onCancel()}>×</a>}
                </div>
                <div className={`dsn-main dsn-message-${model.contentStyle} common-popup-content`}>
                    <ul>
                        {model.getContentForDisplay().map((message, index) =>
                            <li key={index} style={index === 0 ? firstLineStyles : {}}>{message}</li>
                        )}
                    </ul>
                </div>

                <div className="dsn-footer" style={{ "marginTop": "20px" }}>
                    <div className="flex-container" style={{ "justifyContent": "flex-end" }}>
                        <ButtonGroup>
                            {model.showCancel && (
                                <ButtonControl
                                    variant="neutral"
                                    onClick={() => this.onCancel()}
                                    label={model.cancelLabel}
                                />
                            )}
                            {showOk && (
                                <ButtonControl
                                    variant={model.okVariant ?? "brand"}
                                    onClick={() => this.onOkClick()}
                                    dataCy="commonPopup-ok"
                                    label={model.okLabel}
                                />
                            )}
                            {model.altButtonLabel && (
                                <ButtonControl
                                    variant={model.altButtonVariant ?? "brand"}
                                    onClick={() => this.onAltButtonClick()}
                                    dataCy="commonPopup-other"
                                    label={model.altButtonLabel}
                                />
                            )}
                        </ButtonGroup>
                    </div>
                </div>
            </div>
        );
    }

    private onOkClick(): void {
        this.props.model.okAction?.();
        this.props.onCloseCallback();
    }

    private onAltButtonClick(): void {
        this.props.model.altButtonAction?.();
        this.props.onCloseCallback();
    }

    private onCancel(): void {
        this.props.model.cancelAction?.();
        this.props.onCloseCallback();
    }
}

export { CommonErrorComponent };
